import React from "react";
import { EducationTermsCard } from "./EducationTermsCard";
import { EducationTermsUIProvider } from "./EducationTermsUIContext";

export function EducationTermsPage({ history }) {
  const educationTermsUIEvents = {
    openNewEducationTermPage: () => {
      history.push("/egitim-donemleri/ekle");
    },
    openEditEducationTermPage: (id) => {
      history.push(`/egitim-donemleri/duzenle/${id}`);
    }
  };
  
  return (
    <EducationTermsUIProvider educationTermsUIEvents={educationTermsUIEvents}>
      <EducationTermsCard />
    </EducationTermsUIProvider>
 );
}